;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('zlSnackbarContainer', SnackbarContainerDirective)

  SnackbarContainerController.$inject = ['SnackService']

  /**
   * Controller for common SnackbarContainer directive
   * @access private
   * @param SnackService
   * @constructor SnackbarContainerController
   */
  function SnackbarContainerController (SnackService) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        snacks: SnackService.snacks
      })
    }
  }

  SnackbarContainerDirective.$inject = ['$timeout', '$compile', '$rootScope']

  /**
   * Common directive used to create a list to select an item
   * @type Directive
   * @returns {{restrict: string, templateUrl: string, controller: SpinnerController, controllerAs: string, link: link, scope: {items: string, onSelect: string}}}
   * @constructor
   */
  function SnackbarContainerDirective ($timeout, $compile, $rootScope) {
    return {
      restrict: 'A',
      controller: SnackbarContainerController,
      controllerAs: 'snackbarContainer',
      link: link
    }

    function link (scope, element, attributes, controller) {
      scope.snacks = []

      scope.$on('snack:add', function (conf, data) {
        var index = element[0].childElementCount + 1
        var newElement = '<zl-snackbar index="' + index + '" color="snacks[' + index + '].color" delay="snacks[' + index + '].delay" text="snacks[' + index + '].text" action="snacks[' + index + '].action || \'.\'" action-text="snacks[' + index + '].actionText"></zl-snackbar>'

        scope.snacks[index] = data
        var domElement = $compile(newElement)(scope)
        element.append(domElement)

        $timeout(function () {
          domElement.remove()
        }, data.delay + 1000)
      })
    }
  }
})(window.angular, window._)
